export const convertToCurrency = (newValue: string | number | null) => {
    if (newValue === null)
        return '';
    return newValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};